import { createFileRoute } from '@tanstack/react-router';
// applies the saved interface settings app-wide from start-up (the route tree evaluates this file eagerly)
import '@/features/settings/boot';
import { HotkeysPage } from '@/features/settings/HotkeysPage';

/** "Tezkor tugmalar" (556:16851). */
export const Route = createFileRoute('/_authed/_app/settings/hotkeys')({
  component: HotkeysPage,
});
